import * as angular from "angular";
import { HouseOccupant } from "../models/house-occupant.model";

export class HouseOccupantService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/houseoccupant";
        this.v2Root = "/v2/houseoccupant";
    }

    house(hId: string): Promise<object> {
        return this.$http.get(this.apiRoot + "/house/" + hId);
    }

    info(hoId: string): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/" + hoId);
    }

    search(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/search/" + data.id);
    }

    update(houseOccupant: HouseOccupant): Promise<object> {
        return this.$http.post(
            this.v2Root + "/update/" + houseOccupant.hoid,
            houseOccupant
        );
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    count(): Promise<object> {
        return this.$http.get(this.apiRoot + "/count");
    }

    delete(hoId: string): Promise<object> {
        return this.$http.delete(this.apiRoot + "/delete/" + hoId);
    }

    bulk_delete(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_delete", data);
    }

    bulk_edit(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_edit", data);
    }

    bulk_edit_custom_field(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_edit_custom_field", data);
    }

    parties(): Promise<object> {
        return this.$http.get(this.apiRoot + "/parties");
    }
}

angular
    .module("vcServices")
    .service("HouseOccupantService", HouseOccupantService);
